import React from 'react';
import {Col, Row} from 'react-bootstrap';
import Navbar from '../navigation/navbar';
import TitleCard from '../main/title-card';
import LeftSide from '../main/left-side';
import RightSide from '../main/right-side';
import Postit from '../main/postit';
import {Outlet, useLocation} from 'react-router-dom';
import useTranslate from "../useTranslate";

export default function Registration() {
    const strings = useTranslate('Registration');
    const {pathname} = useLocation();
    
    const isFirstStep = pathname !== '/registration/activate';

    return (
        <Navbar nav={false}>
            <Row>
                <LeftSide>
                    <TitleCard title={[strings.registrationTitle, '']}/>
                </LeftSide>
                <Col xs={6} sm={6} md={6} lg={6} className="col-middle">
                    <Outlet/>
                </Col>
                <RightSide>
                    {isFirstStep && (
                        <Postit>
                            <p>{strings.registrationPostit1}</p>
                        </Postit>
                    )}
                </RightSide>
            </Row>
        </Navbar>
    );
}